import { render } from "./continue-drugs.vue?vue&type=template&id=981a1988&scoped=true"
import script from "./continue-drugs.vue?vue&type=script&lang=js"
export * from "./continue-drugs.vue?vue&type=script&lang=js"

import "./continue-drugs.vue?vue&type=style&index=0&id=981a1988&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-981a1988"]])

export default __exports__